import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';

import usePermission from 'routes/usePermission';
import { SETTINGS_RESOURCES, PAGE_NAMES, Entity } from 'constant';

import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useSettingsHome = () => {
	const { hasPermission } = usePermission();

	const isEnabled = (entity: Entity) => {
		return hasPermission({
			configPageName: PAGE_NAMES.settings,
			entity
		});
	};

	return { isEnabled };
};

const SettingsHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useSettingsHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '100%'
			})}>
			{_map(_keys(SETTINGS_RESOURCES), (entity: Entity) => {
				return isEnabled(entity) ? (
					<div
						key={entity}
						className={css({
							height: '130px',
							width: '70%',
							cursor: 'pointer'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[entity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => ({
										width: '100%',
										height: '100%'
									})
								},
								Body: {
									component: () => <CardItem label={LABEL[entity]} img={IMAGE_SOURCE[entity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default SettingsHome;
